import type {
  HotelAutoCompleteSuggestion,
  Polygon,
} from '@libs/trip-planner-interfaces';
import { PolygonType } from '@libs/trip-planner-interfaces';

export function findCityPolygon(polygons: Polygon[]): Polygon | undefined {
  return polygons.find(isCityPolygon);
}

export function getHotelSuggestionSearchPolygon(
  suggestion: HotelAutoCompleteSuggestion
): { id: number; fullName: string } {
  const cityPolygon = findCityPolygon(suggestion.polygons ?? []);

  return cityPolygon
    ? { id: cityPolygon.polygonId, fullName: cityPolygon.fullName }
    : {
        id: suggestion.hotel.mainPolygonId,
        fullName: suggestion.hotel.mainPolygonFullName,
      };
}

function isCityPolygon(polygon: Polygon): boolean {
  return (
    polygon.type === PolygonType.city ||
    String(polygon.type) === PolygonType[PolygonType.city]
  );
}
